import { render, staticRenderFns } from "./LightDarkSwitch.vue?vue&type=template&id=f4476366&scoped=true&"
import script from "./LightDarkSwitch.vue?vue&type=script&lang=ts&"
export * from "./LightDarkSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LightDarkSwitch.vue?vue&type=style&index=0&id=f4476366&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4476366",
  null
  
)

export default component.exports